import React from "react";
import { Route, Routes } from "react-router-dom";
import PlaceSelection from "./PlaceSelection";
import SubscriptionForm from "./SubscriptionForm";
import PaymentPage from "./PaymentPage";
import CompletionPage from "./CompletionPage";
import ErrorPage from "./ErrorPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PlaceSelection />} />
      <Route path="/subscription" element={<SubscriptionForm />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/completion" element={<CompletionPage />} />
      <Route path="/error" element={<ErrorPage />} />
    </Routes>
  );
}
